// imports
import { styled, Switch, SwitchProps } from '@mui/material';

/**
 * A styled MUI switch component
 */
const StyledSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" {...props} />
))(({ theme }) => ({
  width: 46,
  height: 26,
  padding: 0,
  marginRight: 15,
  overflow: 'visible',
  '& .MuiSwitch-switchBase': {
    transform: 'translate(-8px,-9px)',
    margin: 2,
    transitionDuration: '300ms',
    '& .MuiTouchRipple-root .MuiTouchRipple-child': {
      backgroundColor: theme.palette.primary.main,
    },
    '&.Mui-checked': {
      transform: 'translate(11px, -9px)',
      color: '#fff',
      '& .MuiSwitch-thumb': {
        backgroundColor: '#fff',
      },
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        border: 'none',
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '90%',
    // checkmark symbol
    backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" fill="none" stroke="${encodeURIComponent(
      theme.palette.primary.main
    )}" stroke-width="2.5" stroke-linecap="butt" stroke-linejoin="miter"/></svg>')`,
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    boxShadow: 'none',
    position: 'relative',
    width: 22,
    height: 22,
    backgroundColor: `${theme.palette.grey[600]}`,
  },
  '& .MuiSwitch-thumb:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '60%',
    // minus symbol
    backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="white" d="M19 14H5v-3h14v3z"/></svg>')`,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    border: `1px solid ${theme.palette.grey[600]}`,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));

export default StyledSwitch;
